import gql from 'graphql-tag'

export const UPSERTCATEGORY = gql`
    mutation upsertCategory(
        $id: ID!
        $name: String!
        $description: String
        $color: String
        $is_project_category: Boolean
        $is_company_category: Boolean
    ){
        upsertCategory(
            input: {
                id: $id
                name: $name
                description: $description
                color: $color
                is_project_category: $is_project_category
                is_company_category: $is_company_category
            }
        ){
            id
            name
            description
            color
            is_project_category
            is_company_category
            deleted_at
        }
    }

`
export const DELETECATEGORY = gql`
    mutation deleteCategory(
        $id: ID!

    ){
        deleteCategory(
            id: $id
        ){
            id
            deleted_at
            name
            description
            color
        }
    }

`

export const RESTORECATEGORY = gql`
    mutation restoreCategory(
        $id: ID!
    ){
        restoreCategory(
            id: $id
        ){
            id
            deleted_at
            name
            description
            color
        }
    }
`